
import type { ReactNode } from 'react';

type ConfigRowProps = {
  label: string;
  value: ReactNode;
  children: ReactNode;
}

export const ConfigRow: React.FC<ConfigRowProps> = ({ label, value, children }) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between">
      <div className="flex flex-col mb-3 md:mb-0 md:w-1/3">
        <span className="text-body2 text-muted-foreground">{label}</span>
        <span className="text-body2 font-bold text-foreground">{value}</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {children}
      </div>
    </div>
  );
};
